<!-- CustomBreadcrumb.vue -->
<template>
  <nav class="breadcrumb">
    <!-- <span class="home" v-if="homeIcon" @click="clickHome">
      <i :class="homeIcon"></i>
    </span> -->
    <template v-for="(item, index) in items" :key="index">
      <span v-if="index > 0" class="separator">/</span>
      <span class="breadcrumb-item" @click="() => handleClick(item, index)">
        {{ item.label }}
      </span>
    </template>
  </nav>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

defineProps({
  items: {
    type: Array,
    required: true,
  },
  homeIcon: {
    type: String,
    default: "pi pi-home",
  },
});

const emit = defineEmits(["click-item", "click-home"]);

function handleClick(item, index) {
  emit("click-item", { item, index });
}

// function clickHome() {
//   emit("click-home");
// }
</script>

<style scoped>
.breadcrumb {
  gap: 0.15rem;
  font-size: 0.85rem;
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
  color: var(--gray-600);
}
.breadcrumb-item {
  cursor: pointer;
}
.separator {
  margin: 0 0.5rem;
  color: #666;
}
</style>
